module.exports = __webpack_public_path__ + "assets/appcues.0176e925.svg";